<template>
  <div class="wrapper footer">
    <div class="footer_in">
      <span>地址：{{ maps.address }}</span>
      <span>邮箱：{{ maps.email }}</span>
      <span>电话：{{ maps.phoneNumber }}</span>
    </div>
    <div class="footer_in">
      <i class="footerIcon"></i>
      <div>
       Copyright © 2017安徽省立医院版权所有All Rights Reserved. 皖ICP备05009222号-3   Designed by Wanhu
      </div>
    </div>
  </div>
</template>

<script>
import { contactUs } from "@/request/api";
export default {
  name: "HelloWorld",
  data() {
    return {
      maps: [],
    };
  },
  created() {
    this.getmap();
  },
  methods: {
    getmap() {
      let params = {
        blongToMenu: "10_1",
        pageSize: 100,
        pageNumber: 1,
      };
      contactUs(params).then((res) => {
        console.log(res);
        if (res.data.code == 200) {
          this.maps = res.data.data.list[0];
        }
      });
    },
  },
};
</script>

<style scoped>
.footer {
  background-color: #2b2c2c;
  height: 75px;
  padding-top: 13px;
}
.footerIcon {
  width: 18px;
  height: 20px;
  background: url(../../static/images/common/footerIcon.png) no-repeat;
  background-size: cover;
  margin-right: 5px;
}
.footer_in {
  display: flex;
  justify-content: center;
  align-items: center;
  font-size: 14px;
  color: #fff;
  margin-bottom: 7px;
}
.footer_in span {
  margin: 0 30px;
}
.footer a{
  color: #fff;
}
.footer a:hover{
  text-decoration: underline;
}
</style>


// WEBPACK FOOTER //
// src/components/footer.vue